// 皮肤页面
import React, {useContext, useEffect, useState} from "react";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {ITheme, LoginType} from "../../../../common/utils/http/IResponse.ts";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import debounce from "lodash/debounce";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";
import {PageEnum} from "../../../../types/IPage.ts";


type Props = {
    switchPage: (page: PageEnum) => void;
    switchIndex: number;
    isOpened: boolean;
}

const SkinsPage: React.FC<Props> = ({switchPage, switchIndex, isOpened}) => {
    // 全局用户信息provider
    const {user} = useUserContext();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {loadThemeConfig} = useContext(ThemeContext);
    const {addToast} = useContext(ToastContext);
    // 加载中弹窗
    const {showLoading, hideLoading} = useLoading();

    // 主题列表
    const [themeList, setThemeList] = useState<ITheme[]>([]);

    useEffect(() => {
        // GA埋点
        GAEvents.skinsShow()
        if (user?.loginType === LoginType.CGTN) {
            if (switchIndex === 1 && isOpened === true) {
                loadThemeList();
            }
        }
    }, [switchIndex, isOpened]);

    // 加载主题列表
    const loadThemeList = debounce(async () => {
        if (user?.loginType === LoginType.GUEST) return
        try {
            showLoading()
            const response = await apiService.loadThemeList()
            if (response.code === 200) {
                setThemeList(response.data)
            }
        } finally {
            hideLoading()
        }
    }, 100)

    // 设置主题
    const setTheme = debounce(async (themeId: number, equip: boolean) => {
        try {
            showLoading();
            const response = await apiService.equipTheme(themeId, equip);
            if (response.code === 200) {
                addToast({type: 'success', message: response.message})
                // 重载主题列表
                loadThemeList()
                // 刷新主题设置
                loadThemeConfig();
            } else {
                addToast({type: 'error', message: response.message})
            }
        } finally {
            hideLoading();
        }
    }, 100);


    return (
        <div className="display-flex-column height-345 width-333 margin-left-right-auto margin-top-11">
            {/*内部滚动*/}
            {
                user?.loginType === LoginType.GUEST ?
                    <div className="height-345 width-209 margin-left-right-auto text-center">
                        <img className="margin-top-55 width-209 object-fit-contain" src={imgUrls.loginToSeeMore}
                             alt="pic"/>
                        <div className="margin-top-11 my-roboto-regular font-size-16 color-grey">
                            Log in to see more
                        </div>
                        <div onClick={() => switchPage(PageEnum.LOGIN)}
                             className="margin-left-right-auto margin-top-66 height-38 width-113 text-center bg-color-blue-btn color-white my-roboto-medium font-size-14 display-flex-row display-flex-align-items-center display-flex-justify-content-center border-radius-34">
                            Log In
                        </div>
                    </div>
                    :
                    <div className="height-345 overflow-y-auto">
                        {
                            themeList.map((item) => {
                                return (
                                    <div key={item.id}
                                         className="height-192 bg-color-grey border-radius-10 margin-bottom-13 display-flex-column">
                                        <img className="height-133 width-333" alt="pic" src={item.thumbnailUrl}/>
                                        <div
                                            className="width-306 height-59 display-flex-row margin-left-right-auto display-flex-align-items-center display-flex-space-between">
                                            <div className="display-flex-column">
                                                <div className="font-size-16 my-roboto-bold">{item.themeName}</div>
                                                <div
                                                    className="font-size-10 my-roboto-regular color-grey">{item.description}
                                                </div>
                                            </div>
                                            {/*右边的按钮*/}
                                            <div onClick={() => setTheme(item.id, !item.hasEquipped)}
                                                 className={`${item.hasGot ? item.hasEquipped ? 'bg-btn-orange' : 'bg-btn-blue-color' : 'bg-color-grey-btn'} width-73 min-width-73 height-29 border-radius-34 color-white my-roboto-bold font-size-14 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                                                {item.hasGot ? item.hasEquipped ? 'Unequip' : 'Equip' : 'Locked'}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>}
        </div>
    )
}

export default SkinsPage;